import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { ProgressBar } from '@instructure/ui-progress';
import { Tooltip } from '@instructure/ui-tooltip';
import t from 'format-message';
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../../store/shapes.js";
var numQuestionsText = function numQuestionsText(count, usesBank) {
  if (count === null || count === void 0) {
    return null;
  }
  if (usesBank) {
    return jsx(Tooltip, {
      renderTip: t('Variable due to All/Random selection from item bank'),
      color: "primary"
    }, t('Variable Questions'));
  }
  return t("{\n    count, plural,\n        one {1 Question}\n      other {# Questions}\n  }", {
    count: count
  });
};
var HeaderDetails = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(HeaderDetails, _React$Component);
  var _super = _createSuper(HeaderDetails);
  function HeaderDetails() {
    _classCallCheck(this, HeaderDetails);
    return _super.apply(this, arguments);
  }
  _createClass(HeaderDetails, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        outcomeResult = _this$props.outcomeResult,
        showRollups = _this$props.showRollups;
      return jsx("div", null, jsx("span", {
        css: this.props.styles.numQuestions,
        "data-automation": "outcomesPerStudent__numQuestions"
      }, jsx(Text, {
        size: "small"
      }, numQuestionsText(outcomeResult.childArtifactCount, outcomeResult.usesBank))), showRollups ? this.renderRollup(outcomeResult) : null);
    }
  }, {
    key: "renderRollup",
    value: function renderRollup(outcomeResult) {
      return jsx("div", null, jsx(ProgressBar, {
        size: "x-small",
        screenReaderLabel: t('{count} of {total} met mastery', {
          count: outcomeResult.masteryCount,
          total: outcomeResult.count
        }),
        meterColor: "success",
        valueMax: outcomeResult.count,
        valueNow: outcomeResult.masteryCount
      }), jsx("div", {
        css: this.props.styles.masteryBarDetails,
        "data-automation": "outcomesPerStudent__masteryBarDetails"
      }, jsx(Text, {
        size: "x-small",
        "data-automation": "outcomesPerStudent__masteryCount"
      }, t('{count} Mastery', {
        count: outcomeResult.masteryCount
      })), jsx(Text, {
        size: "x-small",
        "data-automation": "outcomesPerStudent__noMasteryCount"
      }, t("{count} Didn't Meet", {
        count: outcomeResult.count - outcomeResult.masteryCount
      }))));
    }
  }]);
  HeaderDetails.displayName = "HeaderDetails";
  return HeaderDetails;
}(React.Component), _class2.propTypes = {
  outcomeResult: PropTypes.object.isRequired,
  showRollups: PropTypes.bool.isRequired,
  styles: stylesShape
}, _class2)) || _class);
export { HeaderDetails as default };